import { MixpanelEventSource } from '@/app/enums';
import { MixpanelEvent } from '@/app/hooks/useAnalytics/types';
import { envs } from '@/app/utils/envs';
import mixpanel from 'mixpanel-browser';

const mixpanelToken = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

if (envs.isMixpanelEnabled && mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    debug: envs.isMixpanelEnabled,
    persistence: 'localStorage',
    ignore_dnt: true,
    api_host: process.env.NEXT_PUBLIC_MIXPANEL_API_HOST,
  });
}

export const mixpanelTrack = (event: MixpanelEvent, properties?: Record<string, any>) => {
  console.log(event, properties);

  if (!envs.isMixpanelEnabled) {
    if (envs.isAnalyticInDebugMode) {
      console.log(`Mixpanel - Skipping ${event}`);
    }
    return;
  }

  mixpanel.track(event, { ...properties, platformSource: MixpanelEventSource.NextJs });
};
